module.exports = __webpack_public_path__ + "img/face-swap-target.79559d73.webp";